module.exports = "../images/suggest-fishing-2@2x.jpg?v=24c09fd";